import { AfterViewInit, Component, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import Swal from "sweetalert2";
import { ChargesService } from "src/app/services/system-config/charges/charges.service";
import { MiscService } from "src/app/services/misc/misc.service";
import { Title } from "@angular/platform-browser";
import { AppCoreService } from "src/app/services/app-core.service";
import { Utilities } from "src/app/models/utilities";
@Component({
    selector: 'app-add',
    templateUrl: './add.component.html',
    styleUrls: ['./add.component.scss']
})

export class AddChargesComponent implements OnInit, AfterViewInit {
    chargesForm: FormGroup;
    isFormSubmitted = false;
    calculationBaseOptions: [];
    chargesOptions: any[] = [];
    dropDownSettings = {};
    selectedCharges: any[] = [];
    chargeTypeOptions: any[] = ['Customer', 'Vendor', 'Supplementary'];
    isAddDisable = false;
    useEnterKey: any;

    permConfig = {
        isViewAllowed: false,
        isAddAllowed: false,
        isEditAllowed: false,
        isDeleteAllowed: false
    };
    
    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private ngxLoaderService: NgxUiLoaderService,
        private chargesService: ChargesService,
        private miscService: MiscService,
        private titleService: Title,
        private appCoreService: AppCoreService,
        private utilities: Utilities,
    ) {
        titleService.setTitle('Charges');
    }

    ngOnInit(): void {
        this.chargesForm = this.formBuilder.group({
            ddlChargeType: [null, Validators.compose([Validators.required])],
            txtName: ['', Validators.compose([Validators.required, Validators.maxLength(50)])],
            ddlCalculationBaseId: [[], Validators.required],
            txtHSNCode: ['', Validators.maxLength(10)],
            txtAmount: [null, Validators.pattern(/^\d{0,18}(\.\d{1,3})?$/)],
            ddlCharges: [null],
            txtTaxSwitch: [false],
            txtFuelSwitch: [false],
            txtTaxOnFuelSwitch: [false],
            txtStatusSwitch: [true],
        });
        this.dropDownSettings = {
            singleSelection: false,
            idField: "id",
            textField: "name",
            selectAllText: "Select All",
            unSelectAllText: "Unselect All",
            itemsShowLimit: 5,
            allowSearchFilter: true,
        }
        this.bindCalculationBase();
        this.bindMultipleCharges();

        this.chargesForm.get('ddlCharges').valueChanges.subscribe(data => {
            this.selectedCharges = data;
        });

        const userData = this.appCoreService.GetUserData();
        this.useEnterKey = !userData.metaInfo.tabbasedtemplate;

        this.checkPermission();
    }

    ngAfterViewInit(): void {
        this.useEnterKey ? this.utilities.focusFirstElement(this.chargesForm) : null;
    }

    checkPermission(): any {
        const userData = this.appCoreService.GetUserData(); 
        const permission = userData.config.filter(x => x.categoryname === 'Manage');
        if (permission.length) {
            this.permConfig.isViewAllowed = permission[0].view;
            this.permConfig.isAddAllowed = permission[0].add;
            this.permConfig.isEditAllowed = permission[0].edit;
            this.permConfig.isDeleteAllowed = permission[0].delete;
        }
    }

    bindCalculationBase() {
        this.miscService.GetAllCalculationBase().subscribe((res) => {
            if (res && res.success) {
                this.calculationBaseOptions = res.data;
            }
        })
    }

    bindMultipleCharges() {
        this.chargesService.GetAll().subscribe((res) => {
            if (res && res.success) {
                this.chargesOptions = res.data.map((item: { id: number, name: string }) => ({
                    id: item.id,
                    name: item.name
                }));
            }
        });
    }

    addCharges() {
        try {
            this.isFormSubmitted = true;
            if (this.chargesForm.invalid) {
                return;
            }
            this.isAddDisable = true;
            const reqObj = {
                id: null,
                chargetype: this.chargesForm.get('ddlChargeType').value,
                name: this.chargesForm.get('txtName').value,
                calculationbaseid: this.chargesForm.get('ddlCalculationBaseId').value,
                hsncode: this.chargesForm.get('txtHSNCode').value,
                amount: this.chargesForm.get('txtAmount').value,
                lnkmultiplechargerefid: this.selectedCharges,
                tax: this.chargesForm.get('txtTaxSwitch').value ?? false,
                fuel: this.chargesForm.get('txtFuelSwitch').value ?? false,
                taxonfuel: this.chargesForm.get('txtTaxOnFuelSwitch').value ?? false,
                isActive: this.chargesForm.get('txtStatusSwitch').value ?? false
            }
            this.ngxLoaderService.start();
            this.chargesService.Add(reqObj).subscribe((res) => {
                if (res && res.success) {
                    this.ngxLoaderService.stop();
                    this.openConfirmationDialog("Record Added Successfully");
                    this.resetForm();
                }
                else if (res && res.success == false) {
                    this.isAddDisable = false;
                    this.ngxLoaderService.stop();
                    const msg = res.message;
                    this.openErrorConfirmationDialog(msg);
                }

            });
            this.ngxLoaderService.stop();

        } catch (e) {
            console.error(e);
        }
    }

    resetForm() {
        this.isFormSubmitted = false;
        this.chargesForm.reset();
        this.isAddDisable = false;
    }

    async openConfirmationDialog(msg: any) {
        const result = await Swal.fire({
            title: 'Success!',
            text: msg,
            icon: 'success',
            confirmButtonText: 'Ok',
            allowEscapeKey: false,
            allowOutsideClick: false
        })
        if (result.isConfirmed) {
            this.router.navigate(['/config/charges/manage'])
        }
    }

    async openErrorConfirmationDialog(msg: any) {
        await Swal.fire({
            title: 'Warning!',
            text: msg,
            icon: 'warning',
            confirmButtonText: 'Ok',
            allowEscapeKey: false,
            allowOutsideClick: false
        })
    }

    blockFormSubmit() {
        return false;
    }

    amountDisable(event: KeyboardEvent): void {
        if (event.key === '-' || event.key === '+' || event.key === 'e') {
            event.preventDefault();
        }
    }

    updateTaxOnFuelSwitch(): void {

        let txtTaxSwitch = this.chargesForm.get('txtTaxSwitch').value;
        let txtFuelSwitch = this.chargesForm.get('txtFuelSwitch').value;
        
        if (txtTaxSwitch && txtFuelSwitch) {
            this.chargesForm.get('txtTaxOnFuelSwitch').setValue(true);
        } else if (!txtTaxSwitch || !txtFuelSwitch) {
            this.chargesForm.get('txtTaxOnFuelSwitch').setValue(false);
        }
    }

    updateTaxFuel(): void {
        let txtTaxOnFuelSwitch = this.chargesForm.get('txtTaxOnFuelSwitch').value;

        if(txtTaxOnFuelSwitch){
            this.chargesForm.get('txtTaxSwitch').setValue(true);
            this.chargesForm.get('txtFuelSwitch').setValue(true);
        }
    }
}